/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a downloadable QR code from any text or URL.`)
};

const es_qr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un código QR descargable a partir de cualquier texto o URL.`)
};

const de_qr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle einen herunterladbaren QR-Code aus beliebigem Text oder einer URL.`)
};

const nl_qr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een downloadbare QR-code van elke tekst of URL.`)
};

const fr_qr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un QR code téléchargeable à partir de n'importe quel texte ou URL.`)
};

const it_qr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un codice QR scaricabile da qualsiasi testo o URL.`)
};

const pt_br2_qr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um código QR para baixar a partir de qualquer texto ou URL.`)
};

const pt_qr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um código QR descarregável a partir de qualquer texto ou URL.`)
};

const ja_qr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意のテキストやURLからダウンロード可能なQRコードを作成します。`)
};

const zh_qr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从任意文本或链接生成可下载的二维码。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_tool_description", locale)
	if (locale === "en") return en_qr_tool_description(inputs)
	if (locale === "es") return es_qr_tool_description(inputs)
	if (locale === "de") return de_qr_tool_description(inputs)
	if (locale === "nl") return nl_qr_tool_description(inputs)
	if (locale === "fr") return fr_qr_tool_description(inputs)
	if (locale === "it") return it_qr_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_qr_tool_description(inputs)
	if (locale === "pt") return pt_qr_tool_description(inputs)
	if (locale === "ja") return ja_qr_tool_description(inputs)
	return zh_qr_tool_description(inputs)
};